class CategorySlider extends HTMLElement {
  constructor() {
    super();
    this.swiperContainer = this.querySelector('.js-category-slider');
    this.swiperInstance = null;
    this.mediaQuery = window.matchMedia('(max-width: 1023px)');
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (!this.swiperContainer) return;
    this.handleResize(this.mediaQuery);
    this.mediaQuery.addEventListener('change', this.handleResize);
  }

  disconnectedCallback() {
    this.mediaQuery.removeEventListener('change', this.handleResize);
    this.destroySwiper();
  }

  handleResize(event) {
    if (event.matches) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  initSwiper() {
    if (this.swiperInstance) return;

    const spaceBetween = Number.parseFloat(this.dataset.spaceBetween);

    this.swiperInstance = new Swiper(this.swiperContainer, {
      slidesPerView: 2.62,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      spaceBetween: Number.isNaN(spaceBetween) ? 4 : spaceBetween,
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

if (!customElements.get('category-slider')) {
  customElements.define('category-slider', CategorySlider);
}